var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"text-center text-black-50 mt-5"},[_c('p',[_vm._v(_vm._s(_vm.copyright))])])}
var staticRenderFns = []

export { render, staticRenderFns }